import { createActionConst } from '../../../utils/action.utils';

const WRIKE_FOLDER_MEETING_NAMESPACE = 'WRIKE_FOLDER_MEETING';

export const STORE_WRIKE_FOLDER_MEETING = createActionConst(
  WRIKE_FOLDER_MEETING_NAMESPACE,
  'STORE_WRIKE_FOLDER_MEETING',
);
export const CLEAR_WRIKE_FOLDER_MEETING = createActionConst(
  WRIKE_FOLDER_MEETING_NAMESPACE,
  'CLEAR_WRIKE_FOLDER_MEETING',
);
